//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import newApi from '@/utils/newModuleApi'

export default {
  data () {
    const now = new Date()
    return {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      data: {},
      weekdays: ['一', '二', '三', '四', '五', '六', '日']
    }
  },
  computed: {
    calendarDays () {
      const days = []
      const first = new Date(this.year, this.month - 1, 1)
      const last = new Date(this.year, this.month, 0).getDate()
      let startWeek = first.getDay()
      startWeek = startWeek === 0 ? 6 : startWeek - 1
      for (let i = 0; i < startWeek; i++) {
        days.push({ key: 'e' + i, day: '', cls: '', empty: true })
      }
      const dayMap = this.data.days || {}
      for (let d = 1; d <= last; d++) {
        const key = String(d).padStart(2, '0')
        const info = dayMap[key] || {}
        days.push({ key: 'd' + d, day: d, cls: info.level || 'none', empty: false })
      }
      return days
    }
  },
  created () { this.load() },
  methods: {
    load () {
      this.$ajax.get(newApi.statsCalendar + '?year=' + this.year + '&month=' + this.month)
        .then(res => { this.data = res || {} })
        .catch(() => { this.$vux && this.$vux.toast.text('加载失败') })
    },
    prevMonth () {
      if (this.month === 1) { this.year--; this.month = 12 } else this.month--
      this.load()
    },
    nextMonth () {
      if (this.month === 12) { this.year++; this.month = 1 } else this.month++
      this.load()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/new/stats/calendar.vue